// AuditLogs only. Shared table methods are in tableMixin.js.
export default {
    name: "AuditLogs",
    methods: {
        // Pretty-print JSON for Old/New Data. Imported rows may be JSON encoded twice, so parse up to twice.
        formatJson(value) {
            if (value === null || value === undefined || value === "") return "-";
            try {
                let parsed = JSON.parse(value);
                if (typeof parsed === "string") parsed = JSON.parse(parsed);
                return JSON.stringify(parsed, null, 2);
            } catch (e) {
                return value; // not JSON: show as-is
            }
        },
    },
};